import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from './Routes/PrivateRoute';
import Private from './screens/Private.jsx';
// import AddUser from './screens/Private copy.jsx'
import fallbackImage from './assests/www1.svg'; // Unificado: misma ruta relativa
import fallbackImageFISART from './assests/logo.svg'; // Unificado: misma ruta relativa
import './App.css';

// 1. Carga perezosa (Lazy Imports) agrupada de forma limpia
const Land = lazy(() => import("./components/land"));
const Login = lazy(() => import("./screens/Login.jsx"));
const Stats = lazy(() => import("./components/blog.js"));
const AddUser = lazy(() => import("./screens/Private copy.jsx"));
const DashBoard = lazy(() => import("./components/Category.jsx"));
const Carrera = lazy(() => import("./components/carreras.js"));
const Cursos = lazy(() => import("./components/Capacitaciones.js"));
const Foro = lazy(() => import("./components/ForoESFA.js"));
const Tramite = lazy(() => import("./components/Tramite.js"));
const Profile = lazy(() => import("./profile"));
const Theme = lazy(() => import("./components/Theme.js"));
const Test = lazy(() => import("./components/taskUser.js"));
const Curses = lazy(() => import("./components/Curses.js"));
const Tests = lazy(() => import("./components/Tests"));

// Estilos declarados fuera del componente para evitar reasignaciones en memoria
const pageStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw'
};

const imageStyle = {
  width: '190px',
  height: '190px',
  borderRadius: '5%',
  position: 'relative'
};

const isTargetHostname = window.location.hostname === "www.esfapa.edu.pe";

// Componente funcional puro para el loader
const Loading = () => (
  <div style={pageStyle}>
    <img
      className="m-auto"
      style={imageStyle}
      src={isTargetHostname ? fallbackImage : fallbackImageFISART}
      alt="Cargando..."
    />
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      {/* 2. Un solo Suspense global que maneja la carga de todas las subrutas perezosas */}
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/" element={<Land />} />
          <Route path="/login" element={<Login />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/carpeta" element={<DashBoard />} />
          <Route path="/carreras" element={<Carrera />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/foro" element={<Foro />} />
          <Route path="/tramites" element={<Tramite />} />
          <Route path="/www" element={<Profile />} />

          {/* Rutas Privadas Protegidas */}
          <Route path="/adduser" element={<PrivateRoute><AddUser /></PrivateRoute>} />
          <Route path="/theme/:theme/:curse" element={<PrivateRoute><Theme /></PrivateRoute>} />
          <Route path="/test/:idtheme/:codetheme" element={<PrivateRoute><Test /></PrivateRoute>} />
          <Route path="/curso/:id" element={<PrivateRoute><Curses /></PrivateRoute>} />
          <Route path="/private" element={<PrivateRoute><Private /></PrivateRoute>} />
          <Route path="/test/:idtest" element={<PrivateRoute><Tests /></PrivateRoute>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}